import Hero from './sections/Hero/Hero';
import Features from './sections/Features/Features';
import HowItWorks from './sections/HowItWorks/HowItWorks';
import WhyChoose from './sections/WhyChoose/WhyChoose';
import CTA from './sections/CTA/CTA';

function Landing() {
  return (
    <div className="landing">
      <Hero />
      <Features />
      <HowItWorks />
      <WhyChoose />
      <CTA />
    </div>
  );
}

export default Landing;
